import React from 'react'
import Dropdown from '../Dropdown';
import { Link } from 'gatsby';
import { XMarkIcon } from '@heroicons/react/24/outline';
import NavElement from '../../models/NavItem';
import { useTranslation } from '../../contexts/TranslationContext';


export default function MobileNavbar({ navItems, lang, open, toggleMenu }: { navItems: any[], lang: string, open: boolean, toggleMenu: () => void }) {

    const { t } = useTranslation();

    const renderMobileNavItems = () => {
        return navItems.map((item: NavElement, index) => {
            if (item.dropdown) {
                return (
                    <li key={index}>
                        <Dropdown
                            title={item.name}
                            items={item.dropdown}
                            path={item.dropdown[0].path}
                            active={location?.pathname.indexOf(item.dropdown[0].path) === 0}
                        />
                    </li>
                );
            } else {
                return (
                    <li key={index} className={`py-4 cap-first text-gray-500 text-xl font-bold transition-all duration-500 underline-offset-8 decoration-2 ${location?.pathname === `/${lang}${item.path}` ? "text-primary" : ""}`}>
                        <Link onClick={toggleMenu} to={`/${lang}${item.path}`}>{t(item.name)}</Link>
                    </li>
                );
            }
        });
    };

    return (
        <>
            {open && <div className='absolute top-0 z-10 bg-[rgba(0,0,0,0.5)] w-full h-full' onClick={toggleMenu}>

            </div>}
            <nav className={`fixed top-0 right-0 bg-white h-screen w-[300px] z-[51] p-8 transition duration-300 ${!open ? "translate-x-[300px]" : ""}`}>
                <button className="flex justify-end w-full" onClick={toggleMenu}> <XMarkIcon className="h-8 w-8" /> </button>
                <ul className="mt-10">
                    {renderMobileNavItems()}
                </ul>
            </nav>
        </>
    )
}
